// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M10.8022 22.5007H5.19783L4.4102 18.9564C3.09004 18.3695 1.44434 17.3534 0.294702 16.2096L0 15.9164V8.50073L1.93381 8.50055L2.88731 6.91154L1.63894 3.79032L2.7735 3.52648C3.88674 3.2676 5.34267 3.33278 6.76717 4.1183L6.78641 4.10683C6.82482 4.08401 6.88 4.05143 6.94869 4.0114C7.08585 3.93145 7.27797 3.82116 7.49871 3.69925C7.9302 3.46095 8.50794 3.15762 9.00293 2.95754C9.45988 2.77284 9.89459 2.61797 10.3167 2.49005C10.1111 3.12299 10 3.79852 10 4.5C10 8.08985 12.9102 11 16.5 11C19.2649 11 21.6266 9.27369 22.566 6.84014C22.5978 6.89303 22.6292 6.94633 22.6603 7.00004C25.1245 11.2683 24.0847 16.5964 20.4341 19.6573L19.8022 22.5007H14.1978L13.7534 20.5007H11.2466L10.8022 22.5007ZM4.5 11.5H6.50391V9.49609H4.5V11.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M16.5 0C18.9853 0 21 2.01472 21 4.5C21 6.98528 18.9853 9 16.5 9C14.0147 9 12 6.98528 12 4.5C12 2.01472 14.0147 0 16.5 0Z"}}]};

const SavingPotFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'saving-pot-filled',
    ref,
    icon: element,
  },
));

SavingPotFilledIcon.displayName = 'SavingPotFilledIcon';

export default SavingPotFilledIcon;
